<div>
  <h5>{{ 'settings.uploadImage.title' | transloco }}</h5>
  <div class="mt-5">
    <nz-upload
      nzType="drag"
      [nzCustomRequest]="customRequest"
      nzMultiple="false"
      nzAccept="image/*"
      [nzShowButton]="imageFileList.length < 1"
      [nzDisabled]="imageFileList.length >= 1"
      [nzFileList]="imageFileList"
      [nzRemove]="handleRemove"
      (nzChange)="handleChange($event)">
      <p class="ant-upload-drag-icon">
        <span nz-icon nzType="inbox"></span>
      </p>
      <p class="ant-upload-text">{{ 'settings.uploadImage.dragText' | transloco }}</p>
      <p class="ant-upload-hint">
        {{ 'settings.uploadImage.hint' | transloco }}
      </p>
    </nz-upload>
  </div>

  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">{{ 'settings.uploadImage.close' | transloco }}</button>
    <button nz-button nzType="primary" (click)="addUrl()" [disabled]="imageFileList.length === 0">{{ 'settings.uploadImage.add' | transloco }}</button>
  </div>
</div>
